import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar";
import api from "../../services/api";

const fmt  = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const fmt4 = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:4,maximumFractionDigits:6});

const STATUS_COR   = {PENDENTE:"var(--z-warning-text)",PAGO:"var(--z-success-text)",CANCELADO:"var(--z-text-muted)"};
const STATUS_LABEL = {PENDENTE:"Pendente",PAGO:"Pago",CANCELADO:"Cancelado"};

// Fornecedores cujos itens NAO sao de producao (escritorio, etc)
const FORNECEDORES_IGNORAR = ["ARMARINHOS FERNANDO LTDA"];

// Converte valor unitario considerando unidade
const precoUnitReal = (valor, unidade) => {
  const v = parseFloat(valor||0);
  const u = (unidade||"").toLowerCase().trim();
  if(["mil","mih"].includes(u)) return v/1000;
  if(["cent","c"].includes(u)) return v/100;
  if(["dz","duz"].includes(u)) return v/12;
  return v;
};

const fmtPrecoUnit = (valor, unidade) => {
  const real = precoUnitReal(valor, unidade);
  return `R$ ${real.toLocaleString("pt-BR",{minimumFractionDigits:4,maximumFractionDigits:6})}/un`;
};

const CATS_NAO_PRODUCAO = ["PRODUTO_FINAL","MONTAGEM_VARAL","MONTAGEM_KIT","MONTAGEM_MV","SEMIACABADO"];

export default function Compras() {
  const [aba, setAba]                     = useState("itens");
  const [pedidos, setPedidos]             = useState([]);
  const [itensProducao, setItensProducao] = useState([]);
  const [itensCompra, setItensCompra]     = useState([]);
  const [loading, setLoading]             = useState(true);
  const [busca, setBusca]                 = useState("");
  const [buscaNF, setBuscaNF]             = useState("");
  const [aberto, setAberto]               = useState(null);
  const [alertaVinculo, setAlertaVinculo] = useState(null);
  const [modalEstoque, setModalEstoque] = useState(null);
  const [estoqueForm, setEstoqueForm]   = useState({tipo:"ENTRADA",quantidade:"",descricao:""});

  const carregar = () => {
    setLoading(true);
    Promise.all([
      api.get("/compras/pedidos/?page_size=1000"),
      api.get("/produtos/produtos/?page_size=1000"),
      api.get("/compras/itens/"),
    ]).then(([pRes,prRes,itRes])=>{
      setPedidos(pRes.data.results||pRes.data);
      const todos = prRes.data.results||prRes.data;
      setItensProducao(todos.filter(p=>!CATS_NAO_PRODUCAO.includes(p.categoria)));
      setItensCompra(itRes.data.results||itRes.data);
    }).finally(()=>setLoading(false));
  };

  useEffect(()=>{carregar();},[]);

  const movimentarEstoque = async () => {
    const {tipo, quantidade, descricao} = estoqueForm;
    if(!quantidade||parseFloat(quantidade)<=0){alert("Informe a quantidade.");return;}
    await api.post("/produtos/movimentos/",{
      produto: modalEstoque.id,
      tipo, quantidade: parseFloat(quantidade),
      descricao: descricao||`${tipo} manual`,
      referencia: "",
      saldo_apos: 0,
    });
    setModalEstoque(null);
    carregar();
  };

  const historicoItem = (itemProdId) =>
    itensCompra
      .filter(ic=>parseInt(ic.produto)===parseInt(itemProdId))
      .map(ic=>({...ic, pedido_obj: pedidos.find(p=>p.id===ic.pedido)}))
      .sort((a,b)=>new Date(b.pedido_obj?.data_emissao||0)-new Date(a.pedido_obj?.data_emissao||0));

  const ultimaCompra = (itemProdId) => historicoItem(itemProdId)[0]||null;

  const deveIgnorar = (ic) => {
    const ped = pedidos.find(p=>p.id===ic.pedido);
    if(!ped) return false;
    const nome = (ped.fornecedor_nome||"").toUpperCase().trim();
    return FORNECEDORES_IGNORAR.some(f=>nome===f.toUpperCase().trim()||nome.includes(f.toUpperCase().trim()));
  };

  const itensNaoVinculados = itensCompra.filter(ic=>!ic.produto && !deveIgnorar(ic));

  const vincularItem = async (itemCompraId, produtoId) => {
    if(!produtoId) return;
    const res = await api.post("/compras/itens/"+itemCompraId+"/vincular/",{produto_id:parseInt(produtoId)});
    if(res.data.precisa_atualizar){
      setAlertaVinculo({
        itemId: itemCompraId,
        produtoNome: res.data.produto_nome,
        produtoCodigo: res.data.produto_codigo,
        precoAtual: res.data.preco_custo_atual,
        precoNovo: res.data.preco_custo_novo,
        valorUnitNF: res.data.valor_unit_nf,
      });
    }
    carregar();
  };

  const vincularGrupo = async (itens, produtoId) => {
    for(const ic of itens) await vincularItem(ic.id, produtoId);
  };

  const importarXML = async (e) => {
    const files = Array.from(e.target.files);
    if(!files.length) return;
    let ok=0, skip=0, erros=[];
    for(const file of files){
      try{
        const text = await file.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text,"text/xml");
        const NS = "http://www.portalfiscal.inf.br/nfe";
        const g = (el,tag) => el?.getElementsByTagNameNS(NS,tag)?.[0];
        const t = (el,tag,def="") => g(el,tag)?.textContent?.trim()||def;
        const infNFe = doc.getElementsByTagNameNS(NS,"infNFe")?.[0];
        if(!infNFe){skip++;continue;}
        const ide=g(infNFe,"ide"), emit=g(infNFe,"emit"), totalEl=g(infNFe,"total"), cobr=g(infNFe,"cobr");
        const icmsTot=g(totalEl,"ICMSTot");
        const cnpj=t(emit,"CNPJ"), nomeEmit=t(emit,"xNome").replace(/&amp;/g,"&");
        const numNF=t(ide,"nNF"), serie=t(ide,"serie","1");
        const existing=pedidos.find(p=>p.numero_nf===numNF&&p.serie===serie&&p.fornecedor_nome===nomeEmit);
        if(existing){skip++;continue;}
        let fornRes=await api.get("/clientes/contatos/?cnpj="+cnpj);
        let forns=fornRes.data.results||fornRes.data;
        let fornId;
        if(forns.length) fornId=forns[0].id;
        else{const novo=await api.post("/clientes/contatos/",{nome:nomeEmit,cnpj,tipo:"FORNECEDOR",categoria:"FORNECEDOR"});fornId=novo.data.id;}
        const dataEmi=t(ide,"dhEmi","").slice(0,10);
        const vProd=parseFloat(t(icmsTot,"vProd","0")), vFrete=parseFloat(t(icmsTot,"vFrete","0"));
        const vDesc=parseFloat(t(icmsTot,"vDesc","0")), vNF=parseFloat(t(icmsTot,"vNF","0"));
        let venc="";
        const dup=cobr?.getElementsByTagNameNS(NS,"dup")?.[0];
        if(dup) venc=t(dup,"dVenc","");
        const pedido=await api.post("/compras/pedidos/",{fornecedor:fornId,numero_nf:numNF,serie,data_emissao:dataEmi,data_vencimento:venc||null,frete:vFrete,desconto:vDesc,valor_produtos:vProd,valor_total:vNF,status:"PENDENTE"});
        const dets=infNFe.getElementsByTagNameNS(NS,"det");
        // Calcula fator de proporcionalidade (vNF total / vProd total)
        let vProdTotal=0;
        for(const det of dets){const prod=g(det,"prod");if(prod) vProdTotal+=parseFloat(t(prod,"vProd","0"));}
        const fator = vProdTotal>0 ? vNF/vProdTotal : 1;
        for(const det of dets){
          const prod=g(det,"prod");
          if(!prod) continue;
          const qtd=parseFloat(t(prod,"qCom","0"));
          const vProdItem=parseFloat(t(prod,"vProd","0"));
          const vTotalComImp=vProdItem*fator;
          const vUnitComImp=qtd>0?vTotalComImp/qtd:0;
          await api.post("/compras/itens/",{pedido:pedido.data.id,produto:null,cod_xml:t(prod,"cProd"),nome_xml:t(prod,"xProd"),quantidade:qtd,unidade:t(prod,"uCom","un").toLowerCase().slice(0,5),valor_unit:parseFloat(vUnitComImp.toFixed(6)),valor_total:parseFloat(vTotalComImp.toFixed(2)),cfop:t(prod,"CFOP")});
        }
        ok++;
      }catch(err){erros.push(file.name+": "+err.message);}
    }
    e.target.value="";
    carregar();
    alert(`Importado: ${ok} NF(s), ignorado: ${skip}, erros: ${erros.length}${erros.length?"\n"+erros.join("\n"):""}`);
  };

  const excluirNF = async (id) => {
    if(!window.confirm("Excluir NF?")) return;
    await api.delete("/compras/pedidos/"+id+"/");
    carregar();
  };

  // Agrupa itens nao vinculados por cod_xml
  const gruposNaoVinculados = (() => {
    const grupos = {};
    itensNaoVinculados.forEach(ic=>{
      const key = ic.cod_xml||ic.nome_xml;
      if(!grupos[key]) grupos[key]={cod_xml:ic.cod_xml,nome_xml:ic.nome_xml,itens:[],valor_unit:ic.valor_unit,unidade:ic.unidade};
      grupos[key].itens.push(ic);
      grupos[key].valor_unit = ic.valor_unit;
      grupos[key].unidade = ic.unidade;
    });
    return Object.values(grupos).sort((a,b)=>a.nome_xml.localeCompare(b.nome_xml));
  })();

  const itensVinculados = itensProducao.filter(ip=>{
    if(busca) return ip.nome.toLowerCase().includes(busca.toLowerCase())||ip.codigo.toLowerCase().includes(busca.toLowerCase());
    return itensCompra.some(ic=>parseInt(ic.produto)===parseInt(ip.id));
  });

  const pedidosFiltrados = pedidos.filter(p=>
    (p.fornecedor_nome||"").toLowerCase().includes(buscaNF.toLowerCase())||
    String(p.numero_nf).includes(buscaNF)
  );

  return(
    <>
      <Topbar title="Compras"/>
      <div className="erp-content">

        <div className="flex-row mb-12">
          <button className={"btn btn-secondary"+(aba==="itens"?" aba-ativa":"")} onClick={()=>setAba("itens")}>
            <i className="ti ti-box"/> Itens de Compra
            {gruposNaoVinculados.length>0&&<span style={{marginLeft:6,background:"var(--z-danger-text)",color:"#fff",borderRadius:10,padding:"1px 6px",fontSize:10}}>{gruposNaoVinculados.length}</span>}
          </button>
          <button className={"btn btn-secondary"+(aba==="nfs"?" aba-ativa":"")} onClick={()=>setAba("nfs")}>
            <i className="ti ti-file-invoice"/> Notas Fiscais ({pedidos.length})
          </button>
        </div>

        {aba==="itens"&&(
          <>
            <div className="page-toolbar">
              <input className="form-input" style={{width:280}} placeholder="Buscar item de producao..." value={busca} onChange={e=>setBusca(e.target.value)}/>
              {gruposNaoVinculados.length>0&&<span style={{fontSize:12,color:"var(--z-danger-text)",fontWeight:600}}>{gruposNaoVinculados.length} tipos aguardando vinculacao</span>}
            </div>

            {gruposNaoVinculados.length>0&&!busca&&(
              <div className="card" style={{marginBottom:12,border:"1px solid #fde68a"}}>
                <div style={{padding:"10px 16px",background:"#fffbeb",borderBottom:"1px solid #fde68a",fontSize:13,fontWeight:600,color:"#92400e"}}>
                  <i className="ti ti-alert-triangle"/> Aguardando vinculacao — {gruposNaoVinculados.length} tipos
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead><tr>
                      <th>Cod XML</th><th>Descricao XML</th>
                      <th className="td-r">NFs</th>
                      <th className="td-r">Ultimo preco unit</th>
                      <th style={{minWidth:220}}>Vincular a</th>
                    </tr></thead>
                    <tbody>
                      {gruposNaoVinculados.map(g=>{
                        const nfs=[...new Set(g.itens.map(ic=>{const p=pedidos.find(x=>x.id===ic.pedido);return p?.numero_nf;}).filter(Boolean))];
                        return(
                          <tr key={g.cod_xml||g.nome_xml}>
                            <td style={{fontSize:11,color:"var(--z-text-muted)",fontFamily:"monospace"}}>{g.cod_xml}</td>
                            <td>
                              <strong className="fs-12">{g.nome_xml}</strong>
                              <span style={{fontSize:10,color:"var(--z-text-muted)",marginLeft:6}}>{nfs.join(", ")}</span>
                            </td>
                            <td style={{textAlign:"right",fontSize:12}}>{g.itens.length}</td>
                            <td style={{textAlign:"right",fontSize:12,fontWeight:600}}>{fmtPrecoUnit(g.valor_unit,g.unidade)}</td>
                            <td onClick={e=>e.stopPropagation()}>
                              <select style={{fontSize:11,padding:"2px 6px",border:"1px solid var(--z-border)",borderRadius:4,width:"100%"}}
                                value="" onChange={e=>{if(e.target.value) vincularGrupo(g.itens,e.target.value);}}>
                                <option value="">-- Selecione --</option>
                                {itensProducao.sort((a,b)=>a.nome.localeCompare(b.nome)).map(ip=>(
                                  <option key={ip.id} value={ip.id}>{ip.codigo} — {ip.nome}</option>
                                ))}
                              </select>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="card">
              <div className="table-wrapper">
                {loading?<div className="table-empty">Carregando...</div>:
                !itensVinculados.length?<div className="table-empty">{busca?"Nenhum item encontrado.":"Nenhum item vinculado ainda."}</div>:
                <table>
                  <thead><tr>
                    <th>Codigo</th><th>Nome</th><th>Unidade</th>
                    <th className="td-r">Preco Atual</th>
                    <th className="td-r">Estoque</th>
                    <th>Ultima Compra</th><th>Fornecedor</th>
                    <th className="td-r">Valor NF (unit)</th>
                    <th></th>
                  </tr></thead>
                  <tbody>
                    {itensVinculados.map(ip=>{
                      const ult=ultimaCompra(ip.id);
                      const ped=ult?.pedido_obj;
                      const open=aberto===ip.id;
                      const hist=historicoItem(ip.id);
                      const precoNFReal=ult?precoUnitReal(ult.valor_unit,ult.unidade):null;
                      const diverge=precoNFReal!==null&&Math.abs(parseFloat(ip.preco_custo)-precoNFReal)>0.0001;
                      return(
                        <React.Fragment key={ip.id}>
                          <tr className="tr-expandable" onClick={()=>setAberto(open?null:ip.id)}>
                            <td style={{fontFamily:"monospace",fontSize:11}}>{ip.codigo}</td>
                            <td><strong>{ip.nome}</strong></td>
                            <td className="fs-12 text-muted">{ip.unidade}</td>
                            <td style={{textAlign:"right",fontWeight:700,color:"var(--z-blue)"}}>R$ {fmt4(ip.preco_custo)}</td>
                            <td className="td-r" onClick={e=>e.stopPropagation()}>
                              <span style={{fontSize:12,fontWeight:600,color:parseFloat(ip.estoque||0)<=parseFloat(ip.estoque_minimo||0)&&parseFloat(ip.estoque_minimo||0)>0?"var(--z-danger-text)":"var(--z-success-text)"}}>
                                {parseFloat(ip.estoque||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2})} {ip.unidade}
                              </span>
                              <button className="btn btn-secondary" style={{fontSize:10,padding:"1px 6px",marginLeft:4}}
                                onClick={()=>{setModalEstoque(ip);setEstoqueForm({tipo:"ENTRADA",quantidade:"",descricao:""});}}>
                                +/-
                              </button>
                            </td>
                            <td className="fs-12 text-secondary">
                              {ped?new Date(ped.data_emissao+"T12:00:00").toLocaleDateString("pt-BR"):"—"}
                            </td>
                            <td className="fs-12">{ped?.fornecedor_nome||"—"}</td>
                            <td style={{textAlign:"right",fontSize:12}}>
                              {ult?fmtPrecoUnit(ult.valor_unit,ult.unidade):"—"}
                            </td>
                            <td>
                              {diverge&&(
                                <span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:"#fef3c7",color:"#92400e",whiteSpace:"nowrap"}}>
                                  ⚠ Diverge
                                </span>
                              )}
                            </td>
                          </tr>
                          {open&&(
                            <tr className="tr-dropdown">
                              <td colSpan={8}>
                                <div className="p-dropdown">
                                  <div style={{fontSize:12,fontWeight:600,marginBottom:8,color:"var(--z-text-secondary)"}}>Historico de compras</div>
                                  <table style={{width:"100%",fontSize:12}}>
                                    <thead><tr className="bg-page">
                                      <th className="td-l">Data</th>
                                      <th className="td-l">NF</th>
                                      <th className="td-l">Fornecedor</th>
                                      <th className="td-r">Qtd</th>
                                      <th className="td-r">Valor Unit (real)</th>
                                      <th className="td-r">Total NF</th>
                                      <th></th>
                                    </tr></thead>
                                    <tbody>
                                      {hist.map((ic,idx)=>{
                                        const p=ic.pedido_obj;
                                        const isUltimo=idx===0;
                                        const realUnit=precoUnitReal(ic.valor_unit,ic.unidade);
                                        const divergeHist=Math.abs(parseFloat(ip.preco_custo)-realUnit)>0.0001;
                                        return(
                                          <tr key={ic.id} style={{borderBottom:"1px solid var(--z-border)",background:isUltimo?"#f0fdf4":""}}>
                                            <td className="td-p">{p?new Date(p.data_emissao+"T12:00:00").toLocaleDateString("pt-BR"):"—"}</td>
                                            <td className="td-mono">{p?.numero_nf}</td>
                                            <td style={{padding:"4px 8px",fontSize:11}}>{p?.fornecedor_nome}</td>
                                            <td className="td-r">{fmt(ic.quantidade)} {ic.unidade}</td>
                                            <td style={{padding:"4px 8px",textAlign:"right",fontWeight:isUltimo?700:400,color:isUltimo?"var(--z-blue)":""}}>
                                              {fmtPrecoUnit(ic.valor_unit,ic.unidade)}
                                            </td>
                                            <td className="td-r">R$ {fmt(ic.valor_total)}</td>
                                            <td className="td-p">
                                              {isUltimo&&divergeHist&&(
                                                <button className="btn btn-primary" style={{fontSize:10,padding:"2px 8px"}}
                                                  onClick={async(e)=>{
                                                    e.stopPropagation();
                                                    const res=await api.post("/compras/itens/"+ic.id+"/confirmar_preco/");
                                                    carregar();
                                                    alert("Preco atualizado para "+fmtPrecoUnit(res.data.preco_custo_atualizado,"un")+" e propagado!");
                                                  }}>
                                                  Usar este preco
                                                </button>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>}
              </div>
            </div>
          </>
        )}

        {aba==="nfs"&&(
          <>
            <div className="page-toolbar">
              <button className="btn btn-primary" onClick={()=>document.getElementById("xml-input").click()}>
                <i className="ti ti-upload"/> Importar XML
              </button>
              <input id="xml-input" type="file" accept=".xml,.XML" multiple style={{display:"none"}} onChange={importarXML}/>
              <input className="form-input" style={{width:250}} placeholder="Buscar fornecedor ou NF..." value={buscaNF} onChange={e=>setBuscaNF(e.target.value)}/>
            </div>
            <div className="card">
              <div className="table-wrapper">
                {loading?<div className="table-empty">Carregando...</div>:
                !pedidosFiltrados.length?<div className="table-empty">Nenhuma NF encontrada.</div>:
                <table>
                  <thead><tr>
                    <th>NF</th><th>Fornecedor</th><th>Data</th><th>Vencimento</th>
                    <th className="td-r">Total</th><th>Status</th><th></th>
                  </tr></thead>
                  <tbody>
                    {pedidosFiltrados.map(p=>{
                      const open=aberto===("nf-"+p.id);
                      return(
                        <React.Fragment key={p.id}>
                          <tr className="tr-expandable" onClick={()=>setAberto(open?null:("nf-"+p.id))}>
                            <td style={{fontFamily:"monospace"}}>{p.numero_nf} <span style={{fontSize:10,color:"var(--z-text-muted)"}}>s{p.serie}</span></td>
                            <td><strong>{p.fornecedor_nome}</strong></td>
                            <td className="fs-13 text-secondary">{p.data_emissao?new Date(p.data_emissao+"T12:00:00").toLocaleDateString("pt-BR"):"—"}</td>
                            <td className="fs-13 text-secondary">{p.data_vencimento?new Date(p.data_vencimento+"T12:00:00").toLocaleDateString("pt-BR"):"—"}</td>
                            <td style={{textAlign:"right",fontWeight:600}}>R$ {fmt(p.valor_total)}</td>
                            <td><span style={{color:STATUS_COR[p.status],fontWeight:600,fontSize:12}}>{STATUS_LABEL[p.status]}</span></td>
                            <td className="td-r">
                              <button className="btn btn-danger" style={{fontSize:11,padding:"2px 8px"}} onClick={e=>{e.stopPropagation();excluirNF(p.id);}}>Excluir</button>
                            </td>
                          </tr>
                          {open&&(
                            <tr className="tr-dropdown">
                              <td colSpan={7}>
                                <div className="p-dropdown">
                                  <div style={{display:"flex",gap:24,fontSize:13,marginBottom:8}}>
                                    <span>Produtos: <strong>R$ {fmt(p.valor_produtos)}</strong></span>
                                    <span>Frete: <strong>R$ {fmt(p.frete)}</strong></span>
                                    <span>Total: <strong className="text-blue">R$ {fmt(p.valor_total)}</strong></span>
                                  </div>
                                  <table style={{width:"100%",fontSize:12}}>
                                    <thead><tr className="bg-page">
                                      <th className="td-l">Cod XML</th>
                                      <th className="td-l">Descricao</th>
                                      <th className="td-l">Vinculado a</th>
                                      <th className="td-r">Qtd</th>
                                      <th className="td-r">Valor Unit</th>
                                      <th className="td-r">Total</th>
                                    </tr></thead>
                                    <tbody>
                                      {(p.itens||[]).map(it=>(
                                        <tr key={it.id} style={{borderBottom:"1px solid var(--z-border)"}}>
                                          <td className="td-mono">{it.cod_xml}</td>
                                          <td style={{padding:"4px 8px",fontSize:12}}>{it.nome_xml}</td>
                                          <td className="td-p">
                                            {it.produto
                                              ?<span style={{color:"var(--z-success-text)",fontSize:11,fontWeight:600}}>{it.produto_codigo} — {it.produto_nome}</span>
                                              :<span style={{color:"var(--z-danger-text)",fontSize:11}}>Nao vinculado</span>
                                            }
                                          </td>
                                          <td className="td-r-sm">{fmt(it.quantidade)} {it.unidade}</td>
                                          <td className="td-r-sm">{fmtPrecoUnit(it.valor_unit,it.unidade)}</td>
                                          <td style={{padding:"4px 8px",textAlign:"right",fontWeight:600}}>R$ {fmt(it.valor_total)}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>}
              </div>
            </div>
          </>
        )}
      </div>

      {modalEstoque&&(
        <div className="overlay-modal">
          <div style={{background:"#fff",borderRadius:8,padding:24,maxWidth:420,width:"90%",boxShadow:"0 8px 32px rgba(0,0,0,0.2)"}}>
            <div style={{fontSize:15,fontWeight:700,marginBottom:4}}>Movimentar Estoque</div>
            <div style={{fontSize:12,color:"var(--z-text-muted)",marginBottom:16}}>{modalEstoque.codigo} — {modalEstoque.nome}</div>
            <div style={{fontSize:13,marginBottom:16}}>
              Estoque atual: <strong className="text-blue">{parseFloat(modalEstoque.estoque||0).toLocaleString("pt-BR",{minimumFractionDigits:2})} {modalEstoque.unidade}</strong>
            </div>
            <div className="flex-row mb-12">
              {["ENTRADA","SAIDA","AJUSTE"].map(t=>(
                <button key={t} className={"btn "+(estoqueForm.tipo===t?"btn-primary":"btn-secondary")}
                  style={{fontSize:12,flex:1}} onClick={()=>setEstoqueForm(f=>({...f,tipo:t}))}>
                  {t==="ENTRADA"?"+ Entrada":t==="SAIDA"?"- Saida":"= Ajuste"}
                </button>
              ))}
            </div>
            <div className="form-group">
              <label className="form-label">Quantidade ({modalEstoque.unidade})</label>
              <input className="form-input" type="number" value={estoqueForm.quantidade}
                onChange={e=>setEstoqueForm(f=>({...f,quantidade:e.target.value}))} placeholder="0"/>
            </div>
            <div className="form-group">
              <label className="form-label">Descricao (opcional)</label>
              <input className="form-input" value={estoqueForm.descricao}
                onChange={e=>setEstoqueForm(f=>({...f,descricao:e.target.value}))} placeholder="Ex: Compra NF 1234"/>
            </div>
            {estoqueForm.tipo==="AJUSTE"&&<div style={{fontSize:11,color:"var(--z-text-muted)",marginBottom:8}}>Ajuste define o saldo diretamente para o valor informado.</div>}
            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
              <button className="btn btn-secondary" onClick={()=>setModalEstoque(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={movimentarEstoque}>Confirmar</button>
            </div>
          </div>
        </div>
      )}

      {alertaVinculo&&(
        <div className="overlay-modal">
          <div style={{background:"#fff",borderRadius:8,padding:24,maxWidth:440,width:"90%",boxShadow:"0 8px 32px rgba(0,0,0,0.2)"}}>
            <div style={{fontSize:15,fontWeight:700,marginBottom:12}}>Atualizar preco de custo?</div>
            <div style={{fontSize:13,marginBottom:16,color:"var(--z-text-secondary)"}}>
              <strong>{alertaVinculo.produtoCodigo} — {alertaVinculo.produtoNome}</strong>
              <div style={{marginTop:8,display:"flex",gap:16}}>
                <span>Atual: <strong className="text-danger">R$ {fmt4(alertaVinculo.precoAtual)}</strong></span>
                <span>Novo: <strong className="text-success">R$ {fmt4(alertaVinculo.precoNovo)}</strong></span>
              </div>
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button className="btn btn-secondary" onClick={()=>setAlertaVinculo(null)}>Manter atual</button>
              <button className="btn btn-primary" onClick={async()=>{
                await api.post("/compras/itens/"+alertaVinculo.itemId+"/confirmar_preco/");
                setAlertaVinculo(null);
                carregar();
              }}>Atualizar e propagar</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}